import { ArrowRight } from "lucide-react";
import { products } from "@/data/products";

export const CapabilityMatrix = () => (
  <section id="compare" className="py-20 md:py-24 bg-muted/30">
    <div className="container max-w-5xl">
      <p className="font-mono text-xs uppercase tracking-widest text-primary">Product overview</p>
      <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold tracking-tight">Which product fits your need?</h2>
      <div className="mt-10 overflow-x-auto rounded-2xl border border-border bg-card">
        <table className="w-full text-sm">
          <thead className="bg-muted/60">
            <tr>
              <th className="px-5 py-3 text-left font-semibold">Product</th>
              <th className="px-5 py-3 text-left font-semibold">Focus</th>
              <th className="px-5 py-3 text-left font-semibold hidden md:table-cell">Highlights</th>
              <th className="px-5 py-3"><span className="sr-only">Link</span></th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.slug} className="border-t border-border align-top">
                <td className="px-5 py-4">
                  <div className="flex items-center gap-3">
                    <span className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br ${p.accent}`}>
                      <img src={p.icon} alt="" width={22} height={22} className="h-5 w-5" />
                    </span>
                    <span className="font-medium text-foreground">{p.name}</span>
                  </div>
                </td>
                <td className="px-5 py-4 text-foreground/90">{p.tagline}</td>
                <td className="px-5 py-4 text-muted-foreground hidden md:table-cell">{p.positioning}</td>
                <td className="px-5 py-4 text-right">
                  <a href={`/products/${p.slug}/`} aria-label={`Learn more about ${p.name}`} className="inline-flex items-center text-primary font-medium whitespace-nowrap">
                    Details <ArrowRight className="ml-1 h-4 w-4" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);
